import { Routes } from '@angular/router';

import { MpsLoggedInGuard } from '../mps/guards/mps-loggedin.guard';
import { IsAdminGuard } from './modules/_guards/isAdminGuard';

export const applicationRoutes: Routes = [
  {
    path: 'administration',
    loadChildren: () => import('./modules/administration/administration.routes').then((m) => m.routes),
    canActivate: [MpsLoggedInGuard, IsAdminGuard]
  },
  {
    path: 'workspace',
    loadChildren: () => import('./modules/workspace/workspace.routes').then((m) => m.routes),
    canActivate: [MpsLoggedInGuard]
  },
  {
    path: 'indexes',
    loadChildren: () => import('./modules/indexes/indexes.routes').then((m) => m.routes),
    canActivate: [MpsLoggedInGuard]
  },
  {
    path: 'price-list',
    loadChildren: () => import('./modules/price-list/price-list.routes').then((m) => m.routes),
    canActivate: [MpsLoggedInGuard]
  }

];
